export default [
    {
        text: "Devolução e Glosas",
        value: "DevolucaoEGlosas"
    },
    {
        text: "Descontos e Abatimentos Concedidos",
        value: "DescontoEAbatimentoConcedidos"
    },
    {
        text: "Tributos e Contribuições Federais sem a Receita Bruta (PIS 0,65% e COFINS 3%) - (Venda para PPA)",
        value: "TributosVendaPPA"
    },
    {
        text: "Tributos e Contribuições Federais sem a Receita Bruta (PIS 1,65% e COFINS 7,6%) - (Venda de Lastro)",
        value: "TributosVendaLastro"
    },
    {
        text: "(-) Tributos e Contribuições Federais sem a Receita Bruta (PIS sem Compras)",
        value: "TributosPISSemCompras"
    },
    {
        text: "(-) Tributos e Contribuições Federais sem a Receita Bruta (COFINS sem Compras)",
        value: "TributosCOFINSSemCompras"
    },
    {
        text: "Tributos e Contribuições Federais sobre a Receita Estaduais (ICMS 32%)",
        value: "TributosReceitasEstaduais"
    }, {
        text: "Tributos e Contribuições Federais sobre a Receita Municipais",
        value: "TributosRecetiasMunicipais"
    },
    {
        text: "Quota Anual da Reserva Global de Reversão - RGR",
        value: "QuotaAnualRGR"
    },
    {
        text: "Programas de Eficiência Energética - PEE",
        value: "ProgramasPEE"
    },
    {
        text: "Quota Anual da Conta de Desenvolvimento Energético - CDE",
        value: "QuotaAnualCDE"
    },
    {
        text: "Quota Anual da Conta de Consumo de Combustíveis Fósseis - CCC",
        value: "QuotaAnualCCC"
    },
    {
        text: "Encargos do Consumidor - P&D (após Maio/2006)",
        value: "EncargosPD"
    },
    {
        text: "Outras Deduções",
        value: "OutrasDeducoes"
    },
]